import { FC } from 'react';
import { Box, Container, Hidden, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';

interface TopNavSliderProps extends IDefaultArrowsProps {
  labels?: string[];
  onClickIndicator?: (slide: number) => void;
}

export interface IDefaultArrowsProps {
  currentSlide: number;
  totalSlides: Array<number>;
  onClickIndicator?: (slide: number) => void;
}

interface StylesProps extends IDefaultArrowsProps {
  labels: boolean;
}

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    indicatorsWrapper: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      position: 'relative',
      maxWidth: 1250,
      padding: 0,
      marginLeft: theme.spacing(-5),
      [theme.breakpoints.up('sm')]: {
        width: '100%',
        marginLeft: 'auto',
      },
    },
    activeLine: {
      [theme.breakpoints.up('xl')]: {
        transition: 'left .6s ease-out',
        position: 'absolute',
        height: 2,
        top: 64,
        backgroundColor: theme.palette.primary.main,
        width: ({ totalSlides }: StylesProps) => `${(1 / totalSlides.length) * 100}%`,
        left: ({ currentSlide, totalSlides }: StylesProps) => `${(currentSlide / totalSlides.length) * 107}%`,
        // width: ({ totalSlides }: StylesProps) => `${100 / totalSlides.length}%`,
        // left: ({ currentSlide, totalSlides }: StylesProps) => `${[0.5, 19, 37.5, 56, 74, 92][currentSlide]}%`,
      },
    },
    indicator: {
      width: '100%',
      border: 0,
      height: 2,
      marginTop: theme.spacing(3.2),
      outline: 'none',
      backgroundColor: theme.palette.secondary.light,
    },
    buttonSlide: {
      width: '100%',
      padding: 0,
      border: 0,
      background: 'transparent',
      userSelect: 'none',
      cursor: 'pointer',
      transition: 'color 300ms',
      '&:hover': {
        color: theme.palette.info.main,
      },
    },
    labelSlide: {
      marginTop: theme.spacing(3),
      fontSize: 17,
      fontWeight: 500,
      minWidth: 210,
    },
  });
});

const TopNavSlider: FC<TopNavSliderProps> = ({ totalSlides, currentSlide, labels = [], onClickIndicator }) => {
  const classes = useStyles({ currentSlide, totalSlides, onClickIndicator, labels: !!labels.length });

  return (
    <>
      <Container fixed className={classes.indicatorsWrapper}>
        {totalSlides.map((item, index) => (
          <button className={classes.buttonSlide} onClick={() => onClickIndicator?.(index)} key={`indicator-${item}`}>
            {labels[index] && (
              <>
                <Typography
                  align="center"
                  className={classes.labelSlide}
                  style={currentSlide === index ? { color: '#E0621E' } : { color: '#9299A6' }}
                  variant="h6"
                >
                  {labels[index]}
                </Typography>
                <Hidden mdUp>
                  <Box mb={5} />
                </Hidden>
              </>
            )}
          </button>
        ))}
        <div className={classes.activeLine} />
      </Container>
      <Hidden mdDown>
        <div className={classes.indicator} />{' '}
      </Hidden>
    </>
  );
};
export default TopNavSlider;
